//react
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//material-ui design helpers



import { LoadingDialog } from '../dialogs';
import {corestyles} from '../../styles';
import {createItemList } from '../form';
import { formatJsonDataset, formatJsonLocation } from '../renderers';
import { Box } from '@mui/material';

const s:any = {
  ...corestyles,
}

/**
 * -------------------------------------------------------------------
 * Service Panel
 * -------------------------------------------------------------------
 */
class ViewerPanel extends Component<any,any> {
  static propTypes: any;
  static defaultProps: any;
  constructor(props:any) {
    super(props);
    this.state = {
      mode: this.props.mode,
      init: false,
      loading: false,
      fopen: false,
    };
  }

  handleChange = (name:any) => (event:any) => {
    this.setState({
      [name]: event.target.value,
    });
  };

  startLoading = () => {
    this.setState({ loading: true });
  }

  stopLoading = () => {
    this.setState({ loading: false });
  }

  render = () => {
    const { mode, sdata, record, formatters, onChange, classes, selected, reset, cvalue, cuparams } = this.props;
    const { loading } = this.state;
    const extras = {selected, reset, cvalue, cuparams }
    //const formitems = generateItemList(mode, sdata, record, formatters, onChange);
    const formitems = createItemList(mode, sdata, record, formatters, onChange, extras);

    console.log('ViewerPanel.render', formitems);
    return (
      <Box sx={{...s.container}}>
        <Box component='form' id="requestform" sx={{...s.reqform}}>
          {loading &&
            <LoadingDialog status={loading} start={this.startLoading} stop={this.stopLoading} />
          }
          {formitems.map((item:any) => (
            <Box key={item.id}>
              {item.id === 'exi' ||item.id === 'req' || item.id === 'res' ? 
              <Box>
                <Box component='span'>{item.dom.props.label} {formatJsonDataset(item.dom.props.value,record)}</Box>
              </Box>
              : item.id === 'geo' ? 
              <Box component='span'>{item.dom.props.label} {formatJsonLocation(item.dom.props.value,record)}</Box>
              :item.dom
              }
            </Box>
          ))}
        </Box>
      </Box>
    );
  }
};

ViewerPanel.propTypes = {
  service: PropTypes.string.isRequired,
  mode: PropTypes.oneOf(['view']).isRequired,
  sdata: PropTypes.object,
  record: PropTypes.object,
  onChange: PropTypes.func,
  formatters: PropTypes.object,
  layout: PropTypes.object,
};

//ViewerPanel = withStyl...corestyles, { withTheme: true })(ViewerPanel);

export default ViewerPanel;
